const actions = {
  FETCH_BUILDING: "FETCH_BUILDING",
  FETCH_BUILDING_LIST: "FETCH_BUILDING_LIST",
  ERROR_BUILDING: "ERROR_BUILDING",
  LOAD_SITE_LIST: "LOAD_SITE_LIST"
};

export default actions;
